import React, { useState } from 'react';
import { OnboardingLayout } from './common/layout';
import { OtpVerification } from '../../components/common/otp-verification';
import { ROUTE_PATH } from '../../routes/route-paths';
import { useSendKeycloakVerificationCode, useVerifyKeycloakVerificationCode } from '../../hooks/api/useUser';
import useAuth from '../../hooks/utils/useAuth';
import { useHistory } from 'react-router-dom';

export const SMSCodeAuthentication: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();
  const phoneNumberToVerify = user?.mobile_phone_verification_new_number || user?.mobile_phone;
  const { mutate: sendKeycloakVerificationCode } = useSendKeycloakVerificationCode();
  const { mutate: verifyKeycloakVerificationCode } = useVerifyKeycloakVerificationCode();
  const [otpValue, setOtpValue] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = () => {
    if (otpValue.length !== 6) {
      setError('Please enter the 6-digit verification code');
      return;
    }

    setError(null);
    verifyKeycloakVerificationCode(
      {
        verificationCode: otpValue,
      },
      {
        onSuccess: () => {
          history.push(ROUTE_PATH.ONBOARDING_TOPIC_PREFERENCES);
        },
        onError: (error: any) => {
          setError(error.response?.data?.message || 'Invalid verification code. Please try again.');
          setOtpValue('');
        },
      },
    );
  };

  return (
    <OnboardingLayout>
      <div className="mb-6 space-y-1">
        <h1 className="font-albert-sans text-xl font-semibold leading-[1.5] text-black">
          Finally, verify your account.
        </h1>
        <p className="font-open-sans text-sm font-normal leading-[1.5] text-black">
          Enter the verification code that was sent to your mobile phone number.
        </p>
      </div>

      <div className="space-y-4">
        <OtpVerification
          value={otpValue}
          onChange={(value) => {
            setOtpValue(value);
            if (error) {
              setError(null);
            }
          }}
          onSubmit={handleSubmit}
          onResend={() => sendKeycloakVerificationCode({ mobilePhone: phoneNumberToVerify!.replace(/\D/g, '') })}
          error={error}
          phoneNumber={phoneNumberToVerify}
          showCancelButton={false}
          submitButtonText="Verify Account"
          containerStyle="mt-4 mb-8 h-[62px]"
          inputStyle="max-w-[53px] w-full h-full text-center bg-gray-100 text-2xl"
        />
      </div>
    </OnboardingLayout>
  );
};
